'use strict';

var React = require('react'),
    ReactDOM = require('react-dom'),
    Redux = require('redux'),
    Provider = require('react-redux').Provider,
    ThumbnailGallery = require('./components/ThumbnailGallery'),
    TakeScreenshot = require('./components/TakeScreenshot'),
    CommandBuilder = require('./components/CommandBuilder'),
    ExternalNavbar = require('./components/ExternalNavbar'),
    SignupForm = require('./components/SignupForm'),
    DocsExample = require('./components/DocsExample'),
    FlashMessages = require('./components/FlashMessages'),
    dialogsReducer = require('./reducers/dialogsReducer'),
    onReady = require('./utils').onReady;

onReady(function () {
	var store = Redux.createStore(Redux.combineReducers({
		dialogs: dialogsReducer
	}));

	ReactDOM.render(React.createElement(ExternalNavbar, { loggedIn: global.thum.loggedIn }), document.getElementById('external-navbar'));

	ReactDOM.render(React.createElement(
		Provider,
		{ store: store },
		React.createElement(FlashMessages, null)
	), document.getElementById('flash-messages'));

	var thumbnailGallery = document.getElementById('thumbnail-gallery');
	if (thumbnailGallery) {
		ReactDOM.render(React.createElement(ThumbnailGallery, null), thumbnailGallery);
	}

	var takeScreenshot = document.getElementById('take-screenshot');
	if (takeScreenshot) {
		ReactDOM.render(React.createElement(TakeScreenshot, { fullpage: 'false' }), takeScreenshot);
	}

	var takeScreenshotFull = document.getElementById('take-screenshot-full');
	if (takeScreenshot) {
		ReactDOM.render(React.createElement(TakeScreenshot, { fullpage: 'true' }), takeScreenshotFull);
	}

	var commandBuilder = document.getElementById('command-builder');
	if (commandBuilder) {
		ReactDOM.render(React.createElement(CommandBuilder, null), commandBuilder);
	}

	var signupForm = document.getElementById('signup-form');
	if (signupForm) {
		ReactDOM.render(React.createElement(
			Provider,
			{ store: store },
			React.createElement(SignupForm, null)
		), signupForm);
	}

	var docsExample = document.getElementById('docs-example');
	if (docsExample) {
		ReactDOM.render(React.createElement(DocsExample, null), docsExample);
	}
});


//////////////////
// WEBPACK FOOTER
// ./client/external.js
// module id = 410
// module chunks = 0